export const lottery20220807 = {
  startTime: "2022-08-15T18:00:00+08:00",
  registrationDeadline: "2022-08-18T11:00:00+08:00",
  lotteryTime: "2022-08-18T18:00:00+08:00",
};
